import React from "react";
import img01 from "../../assets/img/team/WhatsApp Image 2023-05-15 at 15.22.53.jpg";
import img02 from "../../assets/img/team/WhatsApp Image 2023-05-15 at 15.22.54.jpg";
import img03 from "../../assets/img/team/WhatsApp Image 2023-05-15 at 15.22.58.jpg";
import img04 from "../../assets/img/team/WhatsApp Image 2023-05-18 at 20.00.51.jpg";
import img05 from "../../assets/img/team/team_img05.png";
import img06 from "../../assets/img/team/team_img06.png";
import img07 from "../../assets/img/team/team_img07.png";
import img08 from "../../assets/img/team/team_img08.png";
import TeamOneItem from "./TeamOneItem";

const TeamOne = () => {
  const team_members = [
    {
      src: img01,
      name: "Kris Marszalek",
      designation: "Founder & CO",
    },
    {
      src: img02,
      name: "Matt David",
      designation: "Chief Communicator Officer",
    },
    {
      src: img03,
      name: "Bessie Cooper",
      designation: "Vp People",
    },
    {
      src: img04,
      name: "George Fenimore Truman",
      designation: "Chief Trader",
    },
  ];

  return (
    <section className="team-area pt-130">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-xl-6">
            <div className="section-title text-center mb-70">
              <span className="sub-title">Our team</span>
              <h2 className="title">
                The Leadership <br /> <span>Team</span>
              </h2>
            </div>
          </div>
        </div>

        <div className="row justify-content-center">
          {team_members.map((member, index) => (
            <div key={index} className="col-xl-3 col-md-4 col-sm-6">
              <TeamOneItem item={member} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TeamOne;
